import {Component, OnInit, Input, Output, EventEmitter, ViewChild} from '@angular/core';
import {EnvService} from "../services/env.service";
import {HttpClient, HttpParams} from "@angular/common/http";
import {MicroSelectComponent} from "../shared/select/micro-select.component";

@Component({
  selector: 'micro-service-select',
  templateUrl: './service-select.component.html'
})
export class ServiceSelectComponent implements OnInit  {
  @ViewChild("sel", {static: true}) sel:MicroSelectComponent;

  @Input()
  mode:string = 'simple';

  @Output()
  serviceChange:EventEmitter<any> = new EventEmitter<any>();

  @Input()
  service:any = '';

  @Input()
  required:boolean = false;

  @Input()
  disabled:boolean = false;

  options:any[];

  change(e) {
    this.serviceChange.emit(e);
  }

  constructor(private env:EnvService, private http:HttpClient) {
  }

  ngOnInit(): void {
    this.reload();
  }

  reload() {
    let params:HttpParams = new HttpParams();
    this.sel.loading = true;
    this.http.get(`${this.env.e.url}/auth/services`, {params:params})
      .subscribe(data => {
        // ServiceLookup uses `service` as its identifier, while the shared
        // select component expects options to expose an `id` property.
        this.options = (data as any[]).map(option => ({
          ...option,
          id: option.id ?? option.service
        }));
        this.sel.loading = false;
      });
  }
}
